// Menü öğesi (item) işlemleri: oluştur / güncelle / sil / toplu sırala.
// Liste/ağaç manager store'unun tree action'ından gelir; burada yalnızca mutasyonlar var.
const actions = {
    async create(_, {data}) {
        const res = await this._vm.axios.post(this._vm.endpoint.get('menu_item'), data)
        return res.data
    },

    async put(_, {id, data}) {
        const res = await this._vm.axios.put(this._vm.endpoint.get('menu_item') + '/' + id, data)
        return res.data
    },

    async delete(_, {id}) {
        const res = await this._vm.axios.delete(this._vm.endpoint.get('menu_item') + '/' + id)
        return res.data
    },

    // Sürükle-bırak sonrası toplu yeniden konumlama: [{id, parent_id, sort}, ...]
    async reorder(_, {items}) {
        const res = await this._vm.axios.post(this._vm.endpoint.get('menu_item_reorder'), {items})
        return res.data
    },
}

export default {namespaced: true, state: () => ({}), getters: {}, actions, mutations: {}}
